import { FilteredEntry } from "../JournalFilter/JournalFiltersList";

export const getKey = (entry: FilteredEntry) => {
  if ("date" in entry) {
    return entry.date;
  }
  return `${entry.from}${entry.to}`;
};
